import React from 'react';
import './CreateNewDrugTypePopup.css';
import Popup from '../../components/popup/Popup';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import Button from '../../components/button/Button';
import UniversalDropDown from '../../components/universalDropDown/UniversalDropDown';
import FontIcon from '../../components/fontIcon/FontIcon';
import CheckBox from '../../inputs/checkBox/CheckBox';
import toasts from '../../utils/toasts';

const categoryOptions = {
	Veterinary: 'Veterinary',
	'Law Enforcement': 'Law Enforcement',
	'Controlled Substance': 'Controlled Substance',
	'Non-Controlled Substance': 'Non-Controlled Substance'
};

const unitsOfMeasurement = {
	mcg: 'mcg',
	mg: 'mg',
	g: 'g'
};

const displayUOM = {
	l: 'l',
	ml: 'ml',
	null: 'default to unit of measurement'
};

export default class CreateNewDrugTypePopup extends FormTemplate {
	constructor(props) {
		super(props);
		this.myRefs = {};
	}

	saveNewDrugType = async () => {
		let isValid = this.isValid();
		if (!isValid) {
			toasts.show('Not valid');
			return;
		}
		let formObject = this.getValue();
		if (formObject.display_unit_of_measurement === 'null') {
			delete formObject.display_unit_of_measurement;
		}
		await this.props.onComplete(formObject);
		this.props.onClose();
	};

	render() {
		let show = this.props.show;
		if (!this.props.hasOwnProperty('show')) {
			show = true;
		}

		return (
			<Popup {...this.props} show={show} className="g-create-drug-type-popup">
				<Card>
					<FontIcon className="close-icon" onClick={this.props.onClose} name="icon-close" />
					<Label large black center>
						Create a New Drug
					</Label>
					<Input className="name" required placeholder="Drug Name" ref={(ref) => (this.myRefs.name = ref)} />
					<UniversalDropDown
						required
						className="unit-of-measurement"
						placeholder="Unit of Measurement"
						options={unitsOfMeasurement}
						ref={(ref) => (this.myRefs.unit_of_measurement = ref)}
					/>
					<UniversalDropDown
						required
						className="display-unit-of-measurement"
						placeholder="Display Unit of Measurement"
						options={displayUOM}
						ref={(ref) => (this.myRefs.display_unit_of_measurement = ref)}
					/>
					<UniversalDropDown
						required
						className="categories"
						placeholder="Category"
						options={categoryOptions}
						ref={(ref) => (this.myRefs.categories = ref)}
					/>
					<div className="checkbox-row">
						<CheckBox className="is-reusable" title="Reusable" ref={(ref) => (this.myRefs.is_reusable = ref)} />
						<Label black>Reusable (multi-use)</Label>
					</div>
					<div className="actions">
						<Button color="white" bg="blue" onClick={this.saveNewDrugType}>
							Save
						</Button>
					</div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/createNewDrugTypePopup/CreateNewDrugTypePopup.jsx